/* Áudio
   ========================================================================== */

let sound;

if (window.navigator.userAgent.indexOf('Android') > -1) {
  sound = new Howl({
    src: ['audios/elo.m4a', 'audios/elo.mp3'],
    html5: true,
  });
} else {
  sound = new Howl({
    src: ['audios/elo.m4a', 'audios/elo.mp3'],
  });
}

sound.once('load', () => {
  document.body.classList.remove('loading');
});
